module.exports = __webpack_public_path__ + "public/SiteIcons/moreApproveHove.svg?feae9b38";